import { createContext, useState, useContext } from "react";

const AuthContext = createContext(); // Create a context to hold authentication state and functions (login, logout)

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem("token") || null); // Initialize token state from localStorage if it exists, otherwise null

  // Function to log in: save the token to localStorage and update the state
  const login = (newToken) => {
    localStorage.setItem("token", newToken);
    setToken(newToken);
  };

  // Function to log out: remove the token from localStorage and update the state
  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
  };

  // Provide the token and auth functions to all child components that consume this context
  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
// Custom hook to easily access the AuthContext in any component
export function useAuth() {
  return useContext(AuthContext);
}
